import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    overlayId: String,
    sheetId: String,
    lockClass: { type: String, default: "nc-body-locked" },
    openClass: { type: String, default: "nc-open" }
  }

  connect() {
    // Auto-open when turbo frame loads content (for booking sheets)
    if (this.element.id.includes("booking")) {
      document.addEventListener("turbo:frame-load", this.autoOpen.bind(this))
    }
    
    this.boundKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    if (this.element.id.includes("booking")) {
      document.removeEventListener("turbo:frame-load", this.autoOpen.bind(this))
    }
    document.removeEventListener("keydown", this.boundKeydown)
    this.restoreBodyScroll()
  }

  autoOpen(event) {
    // Check if the frame load is for our booking sheet frame
    if (event.target.id === "booking_sheet" && event.target.innerHTML.trim() !== "") {
      this.openModal()
    }
  }

  toggleModal(event) {
    event?.preventDefault()
    event?.stopPropagation()

    const overlay = document.getElementById(this.overlayIdValue)
    const sheet = document.getElementById(this.sheetIdValue)
    if (!overlay || !sheet) return

    if (sheet.classList.contains(this.openClassValue)) {
      this.closeModal()
    } else {
      this.openModal()
    }
  }

  openModal() {
    const overlay = document.getElementById(this.overlayIdValue)
    const sheet = document.getElementById(this.sheetIdValue)
    if (!overlay || !sheet) return

    document.body.classList.add(this.lockClassValue)
    overlay.classList.remove('hidden')
    overlay.style.opacity = '1'
    overlay.style.pointerEvents = 'auto'
    overlay.classList.add(this.openClassValue)
    // Force reflow before adding open to sheet for animation
    sheet.offsetHeight
    sheet.classList.remove('translate-y-full')
    sheet.classList.add(this.openClassValue)

    document.addEventListener("keydown", this.boundKeydown)

    // Focus management - focus first input after animation
    setTimeout(() => {
      const firstInput = sheet.querySelector('input, textarea, select')
      if (firstInput) {
        firstInput.focus()
      }
    }, 300)
  }

  closeModal() {
    const overlay = document.getElementById(this.overlayIdValue)
    const sheet = document.getElementById(this.sheetIdValue)
    if (!overlay || !sheet) return

    sheet.classList.add('translate-y-full')
    sheet.classList.remove(this.openClassValue)
    overlay.style.opacity = '0'
    overlay.style.pointerEvents = 'none'
    overlay.classList.add('hidden')
    overlay.classList.remove(this.openClassValue)
    document.body.classList.remove(this.lockClassValue)
    document.removeEventListener("keydown", this.boundKeydown)

    // Clear turbo frame content for booking sheets
    if (this.element.id.includes("booking")) {
      setTimeout(() => {
        const frame = sheet.querySelector('turbo-frame')
        if (frame) {
          frame.innerHTML = ''
        }
      }, 300)
    }
  }

  closeOverlay(event) {
    // Only close if clicking the overlay itself
    if (event.target.id === this.overlayIdValue) {
      this.closeModal()
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.closeModal()
    }
  }

  restoreBodyScroll() {
    document.body.classList.remove(this.lockClassValue)
  }

  // Prevent panel clicks from bubbling to backdrop
  stopPropagation(event) {
    event.stopPropagation()
  }
}